var getFlex = function (flex, basis) {
    if (basis === void 0) { basis = "auto"; }
    if (flex === true) {
        return "1 1 " + basis;
    }
    if (flex === false) {
        return "0 0 " + basis;
    }
    if (flex === "grow") {
        return "1 0 " + basis;
    }
    if (flex === "shrink") {
        return "0 1 " + basis;
    }
    if (typeof flex === "number") {
        return flex + " 0 " + basis;
    }
    if (typeof flex !== "object") {
        return "";
    }
    var grow = flex.grow, shrink = flex.shrink;
    return grow + " " + shrink + " " + basis;
};
export default (function (_a) {
    var flex = _a.flex, basis = _a.basis;
    if (flex === undefined && basis === undefined) {
        return "";
    }
    if (basis && flex === undefined) {
        return "flex-basis: " + basis + ";";
    }
    var flexValue = getFlex(flex, basis);
    return flexValue ? "flex: " + flexValue + ";" : "";
});
